<template>
  <section class="chapter" :class="{ 'chapter--vertical-space': verticalSpace }">
    <div class="chapter__inner">
      <slot/>
    </div>
  </section>
</template>

<script>
export default {
  props: {
    verticalSpace: {
      type: Boolean,
      default: true
    }
  }
}
</script>

<style lang="scss" scoped>
  .chapter {
    color: #000;
    overflow: hidden;
    position: relative;

    &:nth-of-type(odd) {
      background-color: #000;
      @include font-white;
    }

    &.section-contact,
    &:nth-of-type(odd).section-contact {
      min-height: auto;
      background-color: #fff;
      color: #000;
      .section-title,
      .footer {
        z-index: 1;
      }
    }

    &__inner {
      @include grid-container;
    }

    &--vertical-space &__inner {
      padding-top: map-get($grid-space-around, lg) / 2;
      padding-bottom: map-get($grid-space-around, lg) / 2;

      @include media-down(lg) {
        padding-top: map-get($grid-space-around, md);
        padding-bottom: map-get($grid-space-around, md);
      }
    }

    &.section-projects &__inner {
      padding-top: 50px;
      padding-bottom: 48px;

      @include media-up(sm) {
        padding-top: 78px;
        padding-bottom: 36px;
      }

      @include media-up(md) {
        padding-top: 48px;
        padding-bottom: 53px;
      }

      @include media-up(lg) {
        padding-top: 143px;
        padding-bottom: 132px;
      }
    }

    &.section-about &__inner {
      padding-top: 45px;
      padding-bottom: 5px;

      @include media-up(sm) {
        padding-bottom: 31px;
      }

      @include media-up(md) {
        padding-top: 51px;
        padding-bottom: 14px;
      }

      @include media-up(lg) {
        padding-top: 84px;
        padding-bottom: 87px;
      }
    }

    &.section-manifest &__inner {
      padding-top: 64px;
      padding-bottom: 0;

      @include media-up(lg) {
        padding-top: 81px;
      }
    }

    &.section-contact &__inner {
      padding-top: 28px;
      padding-bottom: 0;

      @include media-up(sm) {
        padding-top: 0;
      }
    }

  }
</style>



// WEBPACK FOOTER //
// src/components/Section.vue